import { Description } from './Description';
import { AvisConcerne } from './AvisConcerne';
import { RensComplementairesDivers } from './RensComplementairesDivers';
import { TypeLotsDivers } from './TypeLotsDivers';
import { TypeOuiNon } from './TypeOuiNon';
import { TypeDelaisDivers } from './TypeDelaisDivers';
import { ChampsLibresTexte } from './ChampsLibresTexte';
import { ChampsLibresTexteDate } from './ChampsLibresTexteDate';

export class TypeAnn_DIVER_G1 {

  public lots: TypeLotsDivers;

  public marcheUnique: string;

  public avisConcerne: AvisConcerne;

  public delais: TypeDelaisDivers;

  public description: Description;

  public rens_Complt: RensComplementairesDivers;

  public procedure: ChampsLibresTexteDate;

  public principales: ChampsLibresTexte;

  constructor() {
    this.lots = new TypeLotsDivers();
    this.marcheUnique = '';
    this.avisConcerne = new AvisConcerne();
    this.delais = new TypeDelaisDivers();
    this.description = new Description();
    this.rens_Complt = new RensComplementairesDivers();
    this.procedure = new ChampsLibresTexteDate();
    this.principales = new ChampsLibresTexte();

  }
}
